<template>
  <nav class="side-nav">
    <slot name="header" />
    <ul class="navigation">
      <li :key="item.title + item.route" v-for="item in items">
        <router-link
          class="side-nav__item"
          :exact="item.exact"
          :to="{ name: item.route }"
        >
          <font-awesome-icon class="icon" :icon="item.icon" v-if="item.icon" />
          <span class="label">{{ item.title }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'side-nav',
  props: ['items'],
};
</script>

<style lang="scss" scoped>
.side-nav {
  background: color('background');
  border-right: 1px solid color('grey');
  height: 100%;
  padding-top: 1rem;
  width: 50px;
  position: fixed;
  left: 0;

  &__item {
    padding: 16px 0;
    text-align: center;
    display: block;
    font-size: calc-font-size(18);
    font-weight: 400;
    text-transform: capitalize;

    .label {
      display: none;
    }

    &.router-link-exact-active {
      color: color('primary', 'text');
      background-color: color('primary');
    }
  }

  .navigation {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    flex-direction: column;
  }
}

@media screen and (min-width: 1024px) {
  .side-nav {
    width: 240px;
    min-width: 240px;

    &__item {
      padding: 16px 32px 16px 32px;
      text-align: left;
      .label {
        display: inline-flex;
      }
      .icon {
        margin-right: 0.5em;
      }
    }
  }
}
</style>
